import GalleryItemChangedEvent from '../events/GalleryItemChangedEvent';

/**
 * @callback $w.GalleryItemClickedEventHandler
 * @summary Handles events fired when an image in a gallery is clicked.
 * @param {$w.GalleryItemClickedEvent} event The event that has occurred.
 * @param {$w.$w} $w Deprecated: A selector function. The $w function was used to
 *  enable event handlers to work with elements in [repeaters]($w.Repeater.html). Now, to get
 *  a scoped selector for working with repeater items, use the [$w.at()]($w.html#at) function
 *  and pass it the context property of the event parameter: `$item = $w.at(event.context)`.
 */

/**
 * @class GalleryItemClickedEvent
 * @summary Event that is fired when an image in a gallery is clicked.
 * @memberof $w
 * @mixes $w.GalleryItemChangedEvent
 * @mixes $w.Event
 */
export default class GalleryItemClickedEvent extends GalleryItemChangedEvent {}
